/** In-call marker that this call IS a telehealth session (started from the session). */
export function SessionCallContextChip({
  sessionUuid,
  className = '',
}: {
  sessionUuid?: string | null
  className?: string
}) {
  if (!sessionUuid) return null
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full bg-white/15 px-3 py-1 text-xs font-semibold text-white shadow-sm ring-1 ring-inset ring-white/25 ${className}`}
      data-testid="session-call-context"
    >
      <svg className="h-3.5 w-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} aria-hidden>
        <path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3M4 11h16M5 5h14a1 1 0 011 1v13a1 1 0 01-1 1H5a1 1 0 01-1-1V6a1 1 0 011-1z" />
      </svg>
      Telehealth session
    </span>
  )
}
